export default __webpack_public_path__ + "static/media/BOTTOM-P14-3-2mm-open.cedc5a33.dwg";